// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Accessibility utilities */
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* Main container */
.vegan_toggle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* Filter toggle (if you add this back) */
  /* Main toggler container */
}
@media (min-width: 991px) {
  .vegan_toggle {
    padding: 10px;
  }
}
.vegan_toggle .filter-toggle {
  display: flex;
  align-items: center;
  padding: 5px 10px;
  border-radius: 28px;
  margin-right: 10px;
  cursor: pointer;
}
.vegan_toggle .filter-toggle ion-icon {
  width: 20px;
  height: 20px;
}
@media (min-width: 991px) {
  .vegan_toggle .filter-toggle ion-icon {
    width: 30px;
    height: 30px;
  }
}
.vegan_toggle .filter-toggle p {
  font-size: 14px;
  text-transform: capitalize;
  font-weight: bold;
  color: black;
  padding-left: 5px;
}
@media (min-width: 991px) {
  .vegan_toggle .filter-toggle p {
    font-size: 18px;
  }
}
.vegan_toggle .toggler {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #567e4a;
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.2) inset;
  padding: 1.5px 7px;
  border-radius: 50px;
  width: 225px;
  height: 50px;
  position: relative;
  /* Individual toggle items */
  /* Visual indicator pin */
}
.vegan_toggle .toggler .toggler_item {
  padding: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: AppFontBold;
  font-size: 12px;
  line-height: 19px;
  color: black;
  transition: all 0.4s;
  cursor: pointer;
  width: 33%;
  text-transform: capitalize;
  border: none;
  background: transparent;
  border-radius: 25px;
  /* Focus styles */
  /* Keyboard focus styles */
  /* Hover state */
  /* Active state */
  /* Selected state */
  /* Icon styling */
  /* Text styling */
}
.vegan_toggle .toggler .toggler_item:focus {
  outline: 2px solid white;
  outline-offset: 2px;
  box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.3);
  z-index: 11;
}
.vegan_toggle .toggler .toggler_item:focus-visible {
  outline: 2px solid white;
  outline-offset: 2px;
  box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.3);
}
.vegan_toggle .toggler .toggler_item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
.vegan_toggle .toggler .toggler_item:active {
  transform: scale(0.95);
}
.vegan_toggle .toggler .toggler_item.selected {
  z-index: 10;
  color: var(--ion-color-secondary);
}
.vegan_toggle .toggler .toggler_item.selected:focus {
  outline-color: var(--ion-color-primary-shade);
  box-shadow: 0 0 0 4px rgba(113, 167, 97, 0.4);
}
.vegan_toggle .toggler .toggler_item ion-icon {
  transition: transform 0.3s ease;
}
.vegan_toggle .toggler .toggler_item p {
  margin: 0;
  pointer-events: none;
}
.vegan_toggle .toggler .toggler_pin {
  position: absolute;
  top: -6px;
  width: 65px;
  height: 65px;
  border-radius: 50%;
  background: var(--ion-color-primary);
  box-shadow: 0px 4px 15px 0px rgba(13, 71, 161, 0.1490196078);
  transition: all 0.3s ease-out;
  pointer-events: none;
  z-index: 5;
  /* Position states */
  /* Pin image (if you add it back) */
}
.vegan_toggle .toggler .toggler_pin.first {
  left: 10px;
}
.vegan_toggle .toggler .toggler_pin.second {
  left: 36%;
}
.vegan_toggle .toggler .toggler_pin.third {
  left: 65%;
}
.vegan_toggle .toggler .toggler_pin .pin_img {
  height: 40px;
  width: 40px;
}

/* Specific styling for different item types */
.all-item {
  position: relative;
  flex-direction: column;
  /* Enhanced focus state for all item */
}
.all-item ion-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40px !important;
  height: 40px !important;
}
.all-item p {
  position: absolute;
  bottom: 4px;
  color: var(--ion-color-secondary);
  font-size: 15px;
  font-family: AppFontBold, sans-serif;
  text-transform: uppercase;
}
.all-item:focus ion-icon {
  transform: translate(-50%, -50%) scale(1.1);
}

.image-block {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 5px;
  /* Enhanced hover state */
  /* Selected state styling */
}
.image-block ion-icon {
  height: 30px;
  transition: transform 0.3s ease;
}
.image-block .first-img {
  width: 30px !important;
  height: 30px !important;
}
.image-block .second-img {
  width: 25px !important;
  height: 25px !important;
}
.image-block p {
  color: white;
  font-size: 12px;
  font-family: AppFontBold, sans-serif;
  text-transform: uppercase;
  margin-top: 4px;
}
.image-block:hover ion-icon {
  transform: scale(1.1);
}
.image-block.selected p {
  color: var(--ion-color-secondary);
  font-weight: bold;
}

/* High contrast mode enhancements */
.bsg-high-contrast .vegan_toggle .toggler {
  background: white;
  border: 2px solid black;
}
.bsg-high-contrast .vegan_toggle .toggler .toggler_item {
  color: black;
}
.bsg-high-contrast .vegan_toggle .toggler .toggler_item:focus {
  outline: 3px solid #0078d7;
  background-color: #e6f3ff;
}
.bsg-high-contrast .vegan_toggle .toggler .toggler_item.selected {
  background-color: #e6f3ff;
  border: 2px solid black;
}
.bsg-high-contrast .vegan_toggle .toggler .toggler_item ion-icon {
  filter: contrast(2);
}
.bsg-high-contrast .vegan_toggle .toggler .toggler_pin {
  background: black;
  border: 2px solid white;
}
.bsg-high-contrast .vegan_toggle .all-item p {
  color: black !important;
}
.bsg-high-contrast .vegan_toggle .all-item.selected p {
  color: white !important;
  background: black;
  padding: 2px 4px;
  border-radius: 4px;
}
.bsg-high-contrast .vegan_toggle .image-block p {
  color: black !important;
}
.bsg-high-contrast .vegan_toggle .image-block.selected p {
  color: white !important;
  background: black;
  padding: 2px 4px;
  border-radius: 4px;
}

/* Reduced motion support */
.bsg-reduced-motion .toggler_item,
.bsg-reduced-motion .toggler_pin,
.bsg-reduced-motion ion-icon {
  transition: none !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .vegan_toggle .toggler {
    width: 160px;
    height: 45px;
  }
  .vegan_toggle .toggler .toggler_item {
    font-size: 11px;
  }
  .vegan_toggle .toggler .toggler_pin {
    width: 55px;
    height: 55px;
    top: -5px;
  }
  .vegan_toggle .toggler .toggler_pin.second {
    left: 50px;
  }
  .vegan_toggle .toggler .toggler_pin.third {
    left: 100px;
  }
  .vegan_toggle .all-item ion-icon {
    width: 35px !important;
    height: 35px !important;
  }
  .vegan_toggle .all-item p {
    font-size: 13px;
  }
  .vegan_toggle .image-block ion-icon {
    height: 25px;
  }
  .vegan_toggle .image-block .first-img {
    width: 25px !important;
    height: 25px !important;
  }
  .vegan_toggle .image-block .second-img {
    width: 22px !important;
    height: 22px !important;
  }
  .vegan_toggle .image-block p {
    font-size: 11px;
  }
}
/* Animation for smooth interactions */
@keyframes slideIn {
  from {
    transform: translateX(-10px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
.toggler_item {
  animation: slideIn 0.3s ease-out;
}

/* Loading state (if needed) */
.toggler_item.loading {
  opacity: 0.6;
  cursor: wait;
}
.toggler_item.loading::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 16px;
  height: 16px;
  border: 2px solid currentColor;
  border-radius: 50%;
  border-top-color: transparent;
  animation: spin 0.8s linear infinite;
  transform: translate(-50%, -50%);
}

@keyframes spin {
  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}
/* Touch improvements for mobile */
@media (hover: none) and (pointer: coarse) {
  .toggler_item {
    min-height: 48px;
    min-width: 48px;
  }
  .toggler_item:hover {
    background-color: transparent;
  }
  .toggler_item:active {
    background-color: rgba(255, 255, 255, 0.2);
  }
}
/* Print styles */
@media print {
  .vegan_toggle .toggler {
    background: white;
    border: 2px solid black;
  }
  .vegan_toggle .toggler .toggler_item {
    color: black;
  }
  .vegan_toggle .toggler .toggler_item.selected {
    background: black;
    color: white;
  }
  .vegan_toggle .toggler .toggler_pin {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/menu-filters/menu-filters.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA,4BAAA;AACA;EACC,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AADD;;AAIA,mBAAA;AACA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EAMA,yCAAA;EAgCA,2BAAA;AArCD;ACnBE;EDeF;IAME,aAAA;EAEA;AACF;AACC;EACC,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AACF;AACE;EACC,WAAA;EACA,YAAA;AACH;ACpCE;EDiCA;IAKE,WAAA;IACA,YAAA;EAEF;AACF;AACE;EACC,eAAA;EACA,0BAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;AACH;ACjDE;ED2CA;IAQE,eAAA;EAEF;AACF;AAGC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,sDAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EAEA,4BAAA;EAmEA,yBAAA;AApEF;AAEE;EACC,UAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;EACA,UAAA;EACA,0BAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EAEA,iBAAA;EAQA,0BAAA;EAOA,gBAAA;EAKA,iBAAA;EAKA,mBAAA;EAWA,iBAAA;EAKA,iBAAA;AApCH;AAJG;EACC,wBAAA;EACA,mBAAA;EACA,8CAAA;EACA,WAAA;AAMJ;AAFG;EACC,wBAAA;EACA,mBAAA;EACA,8CAAA;AAIJ;AAAG;EACC,0CAAA;AAEJ;AAEG;EACC,sBAAA;AAAJ;AAIG;EACC,WAAA;EACA,iCAAA;AAFJ;AAII;EACC,6CAAA;EACA,6CAAA;AAFL;AAOG;EACC,+BAAA;AALJ;AASG;EACC,SAAA;EACA,oBAAA;AAPJ;AAYE;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,4DAAA;EACA,6BAAA;EACA,oBAAA;EACA,UAAA;EAEA,oBAAA;EAaA,mCAAA;AAvBH;AAWG;EACC,UAAA;AATJ;AAYG;EACC,SAAA;AAVJ;AAaG;EACC,SAAA;AAXJ;AAeG;EACC,YAAA;EACA,WAAA;AAbJ;;AAmBA,8CAAA;AACA;EACC,kBAAA;EACA,sBAAA;EAoBA,sCAAA;AAnCD;AAiBC;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,sBAAA;EACA,uBAAA;AAfF;AAkBC;EACC,kBAAA;EACA,WAAA;EACA,iCAAA;EACA,eAAA;EACA,oCAAA;EACA,yBAAA;AAhBF;AAqBE;EACC,2CAAA;AAnBH;;AAwBA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EAyBA,yBAAA;EAOA,2BAAA;AAnDD;AAqBC;EACC,YAAA;EACA,+BAAA;AAnBF;AAsBC;EACC,sBAAA;EACA,uBAAA;AApBF;AAuBC;EACC,sBAAA;EACA,uBAAA;AArBF;AAwBC;EACC,YAAA;EACA,eAAA;EACA,oCAAA;EACA,yBAAA;EACA,eAAA;AAtBF;AA2BE;EACC,qBAAA;AAzBH;AA+BE;EACC,iCAAA;EACA,iBAAA;AA7BH;;AAkCA,oCAAA;AAGE;EACC,iBAAA;EACA,uBAAA;AAjCH;AAmCG;EACC,YAAA;AAjCJ;AAmCI;EACC,0BAAA;EACA,yBAAA;AAjCL;AAoCI;EACC,yBAAA;EACA,uBAAA;AAlCL;AAqCI;EACC,mBAAA;AAnCL;AAuCG;EACC,iBAAA;EACA,uBAAA;AArCJ;AA0CG;EACC,uBAAA;AAxCJ;AA2CG;EACC,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAzCJ;AA8CG;EACC,uBAAA;AA5CJ;AA+CG;EACC,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AA7CJ;;AAmDA,2BAAA;AAEC;;;EAGC,2BAAA;AAjDF;;AAqDA,2BAAA;AACA;EAEE;IACC,YAAA;IACA,YAAA;EAnDD;EAqDC;IACC,eAAA;EAnDF;EAsDC;IACC,WAAA;IACA,YAAA;IACA,SAAA;EApDF;EAsDE;IACC,UAAA;EApDH;EAuDE;IACC,WAAA;EArDH;EA2DC;IACC,sBAAA;IACA,uBAAA;EAzDF;EA4DC;IACC,eAAA;EA1DF;EA+DC;IACC,YAAA;EA7DF;EAgEC;IACC,sBAAA;IACA,uBAAA;EA9DF;EAiEC;IACC,sBAAA;IACA,uBAAA;EA/DF;EAkEC;IACC,eAAA;EAhEF;AACF;AAqEA,sCAAA;AACA;EACC;IACC,4BAAA;IACA,UAAA;EAnEA;EAqED;IACC,wBAAA;IACA,UAAA;EAnEA;AACF;AAsEA;EACC,gCAAA;AApED;;AAuEA,8BAAA;AACA;EACC,YAAA;EACA,YAAA;AApED;AAsEC;EACC,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;EACA,6BAAA;EACA,oCAAA;EACA,gCAAA;AApEF;;AAwEA;EACC;IACC,+CAAA;EArEA;AACF;AAwEA,kCAAA;AACA;EACC;IACC,gBAAA;IACA,eAAA;EAtEA;EAwEA;IACC,6BAAA;EAtED;EAyEA;IACC,0CAAA;EAvED;AACF;AA2EA,iBAAA;AACA;EAEE;IACC,iBAAA;IACA,uBAAA;EA1ED;EA4EC;IACC,YAAA;EA1EF;EA4EE;IACC,iBAAA;IACA,YAAA;EA1EH;EA8EC;IACC,aAAA;EA5EF;AACF","sourcesContent":["@import '../../../theme/mixins';\n\n/* Accessibility utilities */\n.visually-hidden {\n\tposition: absolute;\n\twidth: 1px;\n\theight: 1px;\n\tmargin: -1px;\n\tpadding: 0;\n\toverflow: hidden;\n\tclip: rect(0, 0, 0, 0);\n\twhite-space: nowrap;\n\tborder: 0;\n}\n\n/* Main container */\n.vegan_toggle {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\n\t@include desktop {\n\t\tpadding: 10px;\n\t}\n\n\t/* Filter toggle (if you add this back) */\n\t.filter-toggle {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tpadding: 5px 10px;\n\t\tborder-radius: 28px;\n\t\tmargin-right: 10px;\n\t\tcursor: pointer;\n\n\t\tion-icon {\n\t\t\twidth: 20px;\n\t\t\theight: 20px;\n\n\t\t\t@include desktop {\n\t\t\t\twidth: 30px;\n\t\t\t\theight: 30px;\n\t\t\t}\n\t\t}\n\n\t\tp {\n\t\t\tfont-size: 14px;\n\t\t\ttext-transform: capitalize;\n\t\t\tfont-weight: bold;\n\t\t\tcolor: black;\n\t\t\tpadding-left: 5px;\n\n\t\t\t@include desktop {\n\t\t\t\tfont-size: 18px;\n\t\t\t}\n\t\t}\n\t}\n\n\t/* Main toggler container */\n\t.toggler {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tbackground: #567e4a;\n\t\tbox-shadow: 0px 10px 20px 0px #00000033 inset;\n\t\tpadding: 1.5px 7px;\n\t\tborder-radius: 50px;\n\t\twidth: 225px;\n\t\theight: 50px;\n\t\tposition: relative;\n\n\t\t/* Individual toggle items */\n\t\t.toggler_item {\n\t\t\tpadding: 0;\n\t\t\theight: 100%;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tfont-family: AppFontBold;\n\t\t\tfont-size: 12px;\n\t\t\tline-height: 19px;\n\t\t\tcolor: black;\n\t\t\ttransition: all 0.4s;\n\t\t\tcursor: pointer;\n\t\t\twidth: 33%;\n\t\t\ttext-transform: capitalize;\n\t\t\tborder: none;\n\t\t\tbackground: transparent;\n\t\t\tborder-radius: 25px;\n\n\t\t\t/* Focus styles */\n\t\t\t&:focus {\n\t\t\t\toutline: 2px solid white;\n\t\t\t\toutline-offset: 2px;\n\t\t\t\tbox-shadow: 0 0 0 4px rgba(255, 255, 255, 0.3);\n\t\t\t\tz-index: 11;\n\t\t\t}\n\n\t\t\t/* Keyboard focus styles */\n\t\t\t&:focus-visible {\n\t\t\t\toutline: 2px solid white;\n\t\t\t\toutline-offset: 2px;\n\t\t\t\tbox-shadow: 0 0 0 4px rgba(255, 255, 255, 0.3);\n\t\t\t}\n\n\t\t\t/* Hover state */\n\t\t\t&:hover {\n\t\t\t\tbackground-color: rgba(255, 255, 255, 0.1);\n\t\t\t}\n\n\t\t\t/* Active state */\n\t\t\t&:active {\n\t\t\t\ttransform: scale(0.95);\n\t\t\t}\n\n\t\t\t/* Selected state */\n\t\t\t&.selected {\n\t\t\t\tz-index: 10;\n\t\t\t\tcolor: var(--ion-color-secondary);\n\n\t\t\t\t&:focus {\n\t\t\t\t\toutline-color: var(--ion-color-primary-shade);\n\t\t\t\t\tbox-shadow: 0 0 0 4px rgba(113, 167, 97, 0.4);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t/* Icon styling */\n\t\t\tion-icon {\n\t\t\t\ttransition: transform 0.3s ease;\n\t\t\t}\n\n\t\t\t/* Text styling */\n\t\t\tp {\n\t\t\t\tmargin: 0;\n\t\t\t\tpointer-events: none;\n\t\t\t}\n\t\t}\n\n\t\t/* Visual indicator pin */\n\t\t.toggler_pin {\n\t\t\tposition: absolute;\n\t\t\ttop: -6px;\n\t\t\twidth: 65px;\n\t\t\theight: 65px;\n\t\t\tborder-radius: 50%;\n\t\t\tbackground: var(--ion-color-primary);\n\t\t\tbox-shadow: 0px 4px 15px 0px #0d47a126;\n\t\t\ttransition: all 0.3s ease-out;\n\t\t\tpointer-events: none;\n\t\t\tz-index: 5;\n\n\t\t\t/* Position states */\n\t\t\t&.first {\n\t\t\t\tleft: 10px;\n\t\t\t}\n\n\t\t\t&.second {\n\t\t\t\tleft: 36%;\n\t\t\t}\n\n\t\t\t&.third {\n\t\t\t\tleft: 65%;\n\t\t\t}\n\n\t\t\t/* Pin image (if you add it back) */\n\t\t\t.pin_img {\n\t\t\t\theight: 40px;\n\t\t\t\twidth: 40px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/* Specific styling for different item types */\n.all-item {\n\tposition: relative;\n\tflex-direction: column;\n\n\tion-icon {\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tleft: 50%;\n\t\ttransform: translate(-50%, -50%);\n\t\twidth: 40px !important;\n\t\theight: 40px !important;\n\t}\n\n\tp {\n\t\tposition: absolute;\n\t\tbottom: 4px;\n\t\tcolor: var(--ion-color-secondary);\n\t\tfont-size: 15px;\n\t\tfont-family: AppFontBold, sans-serif;\n\t\ttext-transform: uppercase;\n\t}\n\n\t/* Enhanced focus state for all item */\n\t&:focus {\n\t\tion-icon {\n\t\t\ttransform: translate(-50%, -50%) scale(1.1);\n\t\t}\n\t}\n}\n\n.image-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding-top: 5px;\n\n\tion-icon {\n\t\theight: 30px;\n\t\ttransition: transform 0.3s ease;\n\t}\n\n\t.first-img {\n\t\twidth: 30px !important;\n\t\theight: 30px !important;\n\t}\n\n\t.second-img {\n\t\twidth: 25px !important;\n\t\theight: 25px !important;\n\t}\n\n\tp {\n\t\tcolor: white;\n\t\tfont-size: 12px;\n\t\tfont-family: AppFontBold, sans-serif;\n\t\ttext-transform: uppercase;\n\t\tmargin-top: 4px;\n\t}\n\n\t/* Enhanced hover state */\n\t&:hover {\n\t\tion-icon {\n\t\t\ttransform: scale(1.1);\n\t\t}\n\t}\n\n\t/* Selected state styling */\n\t&.selected {\n\t\tp {\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t\tfont-weight: bold;\n\t\t}\n\t}\n}\n\n/* High contrast mode enhancements */\n.bsg-high-contrast {\n\t.vegan_toggle {\n\t\t.toggler {\n\t\t\tbackground: white;\n\t\t\tborder: 2px solid black;\n\n\t\t\t.toggler_item {\n\t\t\t\tcolor: black;\n\n\t\t\t\t&:focus {\n\t\t\t\t\toutline: 3px solid #0078d7;\n\t\t\t\t\tbackground-color: #e6f3ff;\n\t\t\t\t}\n\n\t\t\t\t&.selected {\n\t\t\t\t\tbackground-color: #e6f3ff;\n\t\t\t\t\tborder: 2px solid black;\n\t\t\t\t}\n\n\t\t\t\tion-icon {\n\t\t\t\t\tfilter: contrast(2);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.toggler_pin {\n\t\t\t\tbackground: black;\n\t\t\t\tborder: 2px solid white;\n\t\t\t}\n\t\t}\n\n\t\t.all-item {\n\t\t\tp {\n\t\t\t\tcolor: black !important;\n\t\t\t}\n\n\t\t\t&.selected p {\n\t\t\t\tcolor: white !important;\n\t\t\t\tbackground: black;\n\t\t\t\tpadding: 2px 4px;\n\t\t\t\tborder-radius: 4px;\n\t\t\t}\n\t\t}\n\n\t\t.image-block {\n\t\t\tp {\n\t\t\t\tcolor: black !important;\n\t\t\t}\n\n\t\t\t&.selected p {\n\t\t\t\tcolor: white !important;\n\t\t\t\tbackground: black;\n\t\t\t\tpadding: 2px 4px;\n\t\t\t\tborder-radius: 4px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/* Reduced motion support */\n.bsg-reduced-motion {\n\t.toggler_item,\n\t.toggler_pin,\n\tion-icon {\n\t\ttransition: none !important;\n\t}\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n\t.vegan_toggle {\n\t\t.toggler {\n\t\t\twidth: 160px;\n\t\t\theight: 45px;\n\n\t\t\t.toggler_item {\n\t\t\t\tfont-size: 11px;\n\t\t\t}\n\n\t\t\t.toggler_pin {\n\t\t\t\twidth: 55px;\n\t\t\t\theight: 55px;\n\t\t\t\ttop: -5px;\n\n\t\t\t\t&.second {\n\t\t\t\t\tleft: 50px;\n\t\t\t\t}\n\n\t\t\t\t&.third {\n\t\t\t\t\tleft: 100px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.all-item {\n\t\t\tion-icon {\n\t\t\t\twidth: 35px !important;\n\t\t\t\theight: 35px !important;\n\t\t\t}\n\n\t\t\tp {\n\t\t\t\tfont-size: 13px;\n\t\t\t}\n\t\t}\n\n\t\t.image-block {\n\t\t\tion-icon {\n\t\t\t\theight: 25px;\n\t\t\t}\n\n\t\t\t.first-img {\n\t\t\t\twidth: 25px !important;\n\t\t\t\theight: 25px !important;\n\t\t\t}\n\n\t\t\t.second-img {\n\t\t\t\twidth: 22px !important;\n\t\t\t\theight: 22px !important;\n\t\t\t}\n\n\t\t\tp {\n\t\t\t\tfont-size: 11px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/* Animation for smooth interactions */\n@keyframes slideIn {\n\tfrom {\n\t\ttransform: translateX(-10px);\n\t\topacity: 0;\n\t}\n\tto {\n\t\ttransform: translateX(0);\n\t\topacity: 1;\n\t}\n}\n\n.toggler_item {\n\tanimation: slideIn 0.3s ease-out;\n}\n\n/* Loading state (if needed) */\n.toggler_item.loading {\n\topacity: 0.6;\n\tcursor: wait;\n\n\t&::after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tleft: 50%;\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\tborder: 2px solid currentColor;\n\t\tborder-radius: 50%;\n\t\tborder-top-color: transparent;\n\t\tanimation: spin 0.8s linear infinite;\n\t\ttransform: translate(-50%, -50%);\n\t}\n}\n\n@keyframes spin {\n\tto {\n\t\ttransform: translate(-50%, -50%) rotate(360deg);\n\t}\n}\n\n/* Touch improvements for mobile */\n@media (hover: none) and (pointer: coarse) {\n\t.toggler_item {\n\t\tmin-height: 48px;\n\t\tmin-width: 48px;\n\n\t\t&:hover {\n\t\t\tbackground-color: transparent;\n\t\t}\n\n\t\t&:active {\n\t\t\tbackground-color: rgba(255, 255, 255, 0.2);\n\t\t}\n\t}\n}\n\n/* Print styles */\n@media print {\n\t.vegan_toggle {\n\t\t.toggler {\n\t\t\tbackground: white;\n\t\t\tborder: 2px solid black;\n\n\t\t\t.toggler_item {\n\t\t\t\tcolor: black;\n\n\t\t\t\t&.selected {\n\t\t\t\t\tbackground: black;\n\t\t\t\t\tcolor: white;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.toggler_pin {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
